import {AxiosResponse} from 'axios';
import {axiosInstance} from '..';


interface Buyer {
  id: number;
  user: {
    id: number;
    name: string;
    email: string;
    charge: string;
    contact_number: string;
    visibility_email: boolean;
    visibility_contact_number: boolean;
  };
  area: {
    id: number;
    name: string;
    x_position: number;
  };
}

interface BuyersResponse {
  message: string;
  userPostions: Buyer[];
}

export function getBuyersList(areaId?: number): Promise<AxiosResponse<BuyersResponse>> {
  return axiosInstance.get(`User/ListBuyersTable`, {
    params: { areaId },
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function getBuyersChart(areaId = null) {
  const url = areaId ? `User/GetBuyersChart?areaId=${areaId}` : 'User/GetBuyersChart';
  return axiosInstance.get(url, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function postBuyersChart(data: any): Promise<AxiosResponse<any, any>> {
  return axiosInstance.post(`User/UploadBuyersUsers`, data, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}







